import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Select, NomineeTypeInfo, JudgeInfo } from '../../application/application.service';

@Component({
    selector: 'dialog-judgeadd-component',
    styleUrls: ['judgeadd.dialogcomponent.scss'],
    templateUrl: 'judgeadd.dialogcomponent.html',
})

export class JudgeAddDialogComponent implements OnInit {

    JudgeForm: FormGroup;
    Judge: JudgeInfo;
    NomineeTypes: NomineeTypeInfo[];
    Districts: string[];
    Phases: Select[] = [{ Value: 1, Display: 'Initial Judging' },
        { Value: 2, Display: 'Initial Judging Tie-Breaker' },
        { Value: 3, Display: 'Final Judging' },
        { Value: 4, Display: 'Final Judging Tie-Breaker' },];

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<JudgeAddDialogComponent>,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.NomineeTypes = this.data.nomTypes;
        this.Judge = this.data.judge;

        if (this.NomineeTypes[0].AwardID === 4) {
            this.Districts = ['0', 'Elementary Youth', 'Elementary Adult', 'Elementary Senior', 'Secondary Youth', 'Secondary Adult', 'Secondary Senior'];
        }
        else {
            this.Districts = ['0', '1', '2', '3', '4', '5', '6', '7'];
        }

        if (this.Judge) {
            this.JudgeForm = this.fb.group({
                FirstName: [this.Judge.FirstName, [Validators.required, Validators.maxLength(50)]],
                LastName: [this.Judge.LastName, [Validators.required, Validators.maxLength(50)]],
                Email: [this.Judge.Email, [Validators.required, Validators.maxLength(100)]],
                JudgingPhase: [this.Judge.JudgingPhase, Validators.required],
                DistrictNumber: [this.Judge.DistrictNumber, Validators.required],
                NomineeTypeID: [this.Judge.NomineeTypeID, Validators.required]
            });
        }
        else {
            this.JudgeForm = this.fb.group({
                FirstName: [null, [Validators.required, Validators.maxLength(50)]],
                LastName: [null, [Validators.required, Validators.maxLength(50)]],
                Email: [null, [Validators.required, Validators.maxLength(100)]],
                JudgingPhase: [null, Validators.required],
                DistrictNumber: [null, Validators.required],
                NomineeTypeID: [null, Validators.required],
                SendEmail: [false]
            });
        }
    }

    Submit(form: FormGroup) {
        if (form.invalid) {
            return;
        }

        this.dialogRef.close(form.value);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

}